<template>
  <v-row v-if="inscricao">
    <template v-for="protocolo in 2">
      <v-col
        class="pa-0 d-flex flex-wrap"
        cols="12"
        :key="`${protocolo}_protocolo`"
      >
        <v-col cols="12" class="text-center py-0">
          <span class="font-weight-bold">TERMO DE COMPROMISSO</span>
        </v-col>

        <v-col cols="12" class="text-justify">
          Declaro para os devidos fins que as informações contidas na presente
          ficha são verdadeiras. Assumo o compromisso de apresentar, quando
          solicitado os comprovantes originais, bem como, qualquer outro
          documento pertinente ao requerimento, sendo que estou ciente das
          penalidades por quaisquer informações falsas, de acordo com o artigo
          299 do Código Penal.
        </v-col>

        <v-col cols="6" class="py-0">
          Unidade:
          {{ inscricao.matricula.unidadeEnsino.nomeCompleto.toUpperCase() }}
        </v-col>

        <v-col cols="6" class="py-0">
          Protocolo:
          {{ inscricao.protocolo }}
        </v-col>

        <v-col cols="6" class="py-0">
          Nome: {{ inscricao.matricula.pessoa.nome.toUpperCase() }}
        </v-col>

        <v-col cols="6" class="py-0">
          Data de nascimento:
          {{
            format(
              parseISO(inscricao.matricula.pessoa.data_nascimento),
              "dd/MM/yyyy"
            )
          }}
        </v-col>

        <v-col cols="6" class="py-0"
          >Rua: {{ inscricao.matricula.pessoa.endereco.logradouro }}</v-col
        >

        <v-col cols="6" class="py-0"
          >N°: {{ inscricao.matricula.pessoa.endereco.numero }}</v-col
        >

        <v-col cols="6" class="py-0"
          >Bairro:
          {{ inscricao.matricula.pessoa.endereco.bairro }}
        </v-col>

        <v-col cols="6" class="py-0"
          >Cidade: {{ inscricao.matricula.pessoa.endereco.cidade.nome }}</v-col
        >

        <v-row v-if="telefones && telefones.length" class="ma-0 pt-5">
          <v-col cols="6" v-for="tel in telefones" :key="tel.id" class="py-0">
            {{ tel.descricao }}: {{ phoneMask(tel.numero) }} ({{
              tel.falarCom
            }})
          </v-col>
        </v-row>

        <v-row v-else class="ma-0">
          <v-col cols="12" class="pb-0"
            >Telefone Residencial/Comercial:
            ____________________________________</v-col
          >
          <v-col cols="12"
            >Telefone do Trabalho: ____________________________________</v-col
          >
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-col cols="12" class="text-center pb-0">
              ____________________________________
            </v-col>
            <v-col cols="12" class="text-center py-0">
              Assinatura do Responsável
            </v-col>
          </v-col>
          <v-col cols="6">
            <v-col cols="12" class="text-center pb-0">
              ____________________________________
            </v-col>
            <v-col cols="12" class="text-center py-0">
              Assinatura do Diretor/Secretário
            </v-col>
          </v-col>
        </v-row>

        <v-col cols="12" class="text-end pa-0">
          Data:
          {{ format(parseISO(inscricao.data_cadastro), "dd/MM/yyyy HH:mm") }}
        </v-col>

        <v-col
          v-if="protocolo === 1"
          cols="12"
          class="d-flex flex-wrap align-center pa-0"
        >
          <v-col cols="auto">
            <v-icon>
              mdi-content-cut
            </v-icon>
          </v-col>

          <v-col>
            <v-divider class="grey" />
          </v-col>
        </v-col>
      </v-col>
    </template>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          id="cvi-print-btn"
          bottom
          class="mr-8 mb-8"
          color="primary"
          dark
          fab
          fixed
          large
          right
          v-on="on"
          @click="print"
        >
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </template>
      Imprimir Termo
    </v-tooltip>
  </v-row>
</template>

<script>
import { format, parseISO } from "date-fns";

export default {
  name: "imprimir-termo-compromisso-plantao",

  props: {
    id: [Number, String]
  },

  data: () => ({
    inscricao: null,
    telefones: null
  }),

  mounted() {
    this.getInscricao();
  },

  methods: {
    async getInscricao() {
      this.inscricao = await this.$http
        .get(`plantao-ferias/${this.id}`)
        .catch(error => this.showMessage(error, "error"));

      if (!this.inscricao) return;

      const pessoa = await this.$erudio
        .get(`pessoas/${this.inscricao.matricula.pessoa.id}`)
        .catch(error => this.showMessage(error, "error"));

      this.telefones = pessoa.telefones;

      setTimeout(this.print, 100);
    },

    phoneMask(value) {
      if (!value) return "";
      value = value.replace(/\D/g, "");
      value = value.replace(/(\d{2})(\d)/, "($1) $2");
      value = value.replace(/(\d)(\d{4})$/, "$1-$2");
      return value;
    },

    print() {
      const appbar = document.querySelector("#app-bar");
      const printBtn = document.querySelector("#cvi-print-btn");

      window.addEventListener("beforeprint", () => {
        appbar.style.display = "none";
        printBtn.style.display = "none";
      });

      window.addEventListener("afterprint", () => {
        appbar.style.display = "inline";
        printBtn.style.display = "inline";
      });

      // Workaround para trocar o <title> do documento
      window.document.title = "Cadastro - Plantão de Férias";

      window.print();

      // Workaround para trocar o <title> do documento
      window.document.title = "Cadastro Vaga Integral";
    },

    format,
    parseISO
  }
};
</script>
